var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoilBtnLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -11.25,
    y: -11.25,
    width: 58.5,
    height: 58.5
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5.62px)",
      clipPath: "url(#bgblur_0_21207_90768_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 11.25
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#232630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 25H10V23H12V25ZM16 25H14V23H16V25ZM20 25H18V23H20V25ZM24 25H22V23H24V25ZM28 25H26V23H28V25ZM10 21H8V19H10V21ZM14 21H12V19H14V21ZM18 21H16V19H18V21ZM22 21H20V19H22V21ZM26 21H24V19H26V21ZM12 17H10V15H12V17ZM16 17H14V15H16V17ZM20 17H18V15H20V17ZM24 17H22V15H24V17ZM28 17H26V15H28V17ZM28 13H8V11H28V13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_21207_90768_clip_path",
    transform: "translate(11.25 11.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoilBtnLayers);
export default __webpack_public_path__ + "static/media/soil-btn-layers.798065bbf13c6366e3ccfb48acede76a.svg";
export { ForwardRef as ReactComponent };